import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/lib/auth";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data: session, isLoading } = useQuery({
    queryKey: ["auth", "session"],
    queryFn: () => authApi.getSession(),
    retry: false,
  });

  if (isLoading) {
    return (
      <div
        className="wf"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <span className="wf-hand-note" style={{ fontSize: 14 }}>
          carregando…
        </span>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
